import { render, staticRenderFns } from "./IncidenceItem.vue?vue&type=template&id=37df5a94&scoped=true&"
import script from "./IncidenceItem.vue?vue&type=script&lang=js&"
export * from "./IncidenceItem.vue?vue&type=script&lang=js&"
import style0 from "./IncidenceItem.vue?vue&type=style&index=0&id=37df5a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df5a94",
  null
  
)

export default component.exports